import store from "@/store";
import Keycloak from "keycloak-js";
import UserInfo from "@/classes/global/UserInfo";

import router from "@/router";
import API from "@/classes/global/API";
import Notification from "@/classes/component-classes/Notification";

let url = new URL(window.location.origin.toString()).hostname;
let owner = url.split('.')[0];

const routeGuardErrorPage = 'routeGuardErrorPage';

const kcConfiguration = {

    url: process.env.VUE_APP_KEYCLOAK_REALM,
    realm: owner,
    clientId: owner,
    onLoad: 'login-required'
}

const options = {
    redirectUri: window.location.href
}

const minTokenValidity = 15;

let keyCloak = new Keycloak(kcConfiguration);
let userInfo = new UserInfo();

export default {

    authenticate(app, axios) {

        // keyCloak.onAuthSuccess = () => this.getUserInfo(app, axios, store.state.loginDetails.sub);

        keyCloak.init({onLoad: 'login-required'}).then(async (authenticated) => {

            if (!authenticated) {
                window.location.reload();

            } else {

                store.state.loginDetails = keyCloak.idTokenParsed;

                userInfo.firstName = keyCloak.idTokenParsed.given_name;
                userInfo.lastName = keyCloak.idTokenParsed.family_name;
                userInfo.email = keyCloak.idTokenParsed.email;

                // keyCloak.idTokenParsed.realm_access.roles

                //Refresh the token just before the service call to the service layer if we only have 15 seconds left
                axios.interceptors.request.use(async (config) => {

                    await keyCloak.updateToken(minTokenValidity).then(function (refreshed) {

                        store.state.loginDetails = keyCloak.refreshTokenParsed;
                        config.headers.Authorization = "Bearer " + keyCloak.token;

                    }).catch(function () {

                        //Override the logout so that if the user logs back in they come to the same place
                        //that they were automatically get logged out then they come bato the same place

                        keyCloak.logout(options)

                    });

                    return config;

                }, function (error) {
                    // Do something with request error
                    return Promise.reject(error);
                });

                //Refresh the token just before we change views if we only have 15 seconds of validity left
                router.beforeResolve(async to => {

                    await keyCloak.updateToken(minTokenValidity)
                        .then(function (refreshed) {

                            store.state.loginDetails = keyCloak.refreshTokenParsed;

                        }).catch(function () {

                            keyCloak.logout(options)

                        });
                });

                //Refresh the token if the user refocuses on the tab views if we only have 15 seconds of validity left
                window.onfocus = async (event) => {

                    await keyCloak.updateToken(minTokenValidity)
                        .then(function (refreshed) {

                            store.state.loginDetails = keyCloak.refreshTokenParsed;

                        }).catch(function () {

                            keyCloak.logout(options)

                        });

                };

             this.getUserInfo(app, axios, store.state.loginDetails.sub);

            }

        }).catch((ex) => {
            //TODO: Add some logging here just incase we have some issues with keycloak - J.Clayton
            console.log(ex)
            console.log("Authenticated Failed");
        });
    },

    async getUserInfo(app, axios, userId) {

        try {

            // Prevent breaking the app if this fails with future browser updates
            store.state.caughtURL = new URL(window.location.href);

        } catch (error) {

            console.log(error)
        }

        await router.isReady();

        const to = router.currentRoute.value

            if(!store.state.userSettings.account) {
                getUserInformation(app, axios, userId, function() {

                    switch (to.name) {

                        case('dashboard'):
                            if (!store.state.mainMenu.dashboard.active)
                                router.push({ name: routeGuardErrorPage});
                            break;
                        case('showshipments'):
                            if (!store.state.mainMenu.shipmentItems.find(x => x.view === to.name).active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('stock'):
                            if(!store.state.mainMenu.warehouseItems.find(x => x.view === to.name).active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('purchaseorder'):
                            if(!store.state.mainMenu.orderItems.find(x => x.id === to.params.id).active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('booking'):
                            if(!store.state.mainMenu.freightItems.find(x => x.section === to.params.section).active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('quote'):
                            if(!store.state.mainMenu.quoteItems.find(x => x.view === to.name).active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('documents'):
                            if(!store.state.mainMenu.documents.active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('reports'):
                            if(!store.state.mainMenu.reports.active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('skuhistory'): case('warehousejobs'): case('pickstock'):
                            if(!store.state.mainMenu.warehouseItems.find(x => x.view === to.name).active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('prejob'):
                            if(!store.state.mainMenu.agentItems.find(x => x.section === to.params.section).active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('home'):
                            if (!store.state.mainMenu.shipments.active) // In router, home is set to show shipments
                                router.push({name: routeGuardErrorPage});
                            break;

                    }

                });
            }



    },

    logout() {

        keyCloak.logout({redirectUri: 'https://' + store.state.owner + '.boxtraxvision.com'});
    }

}

async function getUserInformation(app, axios, userId, callBack) {

    let response = await API.getUserInfoById(userId);

    if (response) {

        userInfo.userId = userId;
        userInfo.account = response.data.account.toLowerCase();
        userInfo.firstName = response.data.firstName? response.data.firstName : "No" ;
        userInfo.lastName = response.data.lastName? response.data.lastName : "Username";

        userInfo.allowColumnMenuSearchShipments = response.data.allowColumnMenuSearchShipments;
        userInfo.searchShipmentColumns = response.data.searchShipmentColumns;
        userInfo.showCourierCustoms = response.data.showCourierCustoms;
        userInfo.showCourierTerms = response.data.showCourierTerms;
        userInfo.highlightActualDate = response.data.highlightActualDate;
        userInfo.showAirTrackingLink = response.data.showAirTrackingLink;
        userInfo.showSeaTrackingLink = response.data.showSeaTrackingLink;
        userInfo.useMeasuredGrid = response.data.useMeasuredGrid;
        userInfo.showShipmentsTabSettings = response.data.showShipmentsTabSettings;
        userInfo.showPickupDelivery = response.data.showPickupDelivery;
        userInfo.showStockValues = response.data.showStockValues;
        userInfo.shipmentTimeFilter = response.data.shipmentTimeFilter;
        userInfo.showShipmentBookings = response.data.showShipmentBookings;
        userInfo.showShipmentJobs = response.data.showShipmentJobs;

        if(response.data.mainMenuConfig?.length > 0) {

            // If menu config fails at server, or is missing, a fallback menu is used from store, only allowing Shipments

            store.state.mainMenu = JSON.parse(response.data.mainMenu.result);
            store.state.menuItems = response.data.mainMenuConfig;

            mapMainMenu();
        } else {

            store.state.banners.error = new Notification(true, `Could Not Load Main Menu Config`);
        }

        store.state.userSettings = userInfo;

        app.mount('#app');

        callBack();

    }

    function mapMainMenu() {

        store.state.menuItems.forEach(item => {

            let [menuItem, index] = item.menuItem.split(':');

            index = parseInt(index);

            if(store.state.mainMenu[menuItem]) {

                item.permitted? store.state.mainMenu[menuItem].active = item.active : false;

                store.state.mainMenu[menuItem].alias = item.alias;

                if(Array.isArray(store.state.mainMenu[menuItem])) {

                    item.permitted? store.state.mainMenu[menuItem][index].active = item.active : false;

                    store.state.mainMenu[menuItem][index].alias = item.alias;

                }
            }

        })

    }

}
